import { useBlocker } from "@tanstack/react-router"

import { useDocuments } from "@/components/documents/context/DocumentsProvider"
import { UncategorizedDocumentEntry } from "@/components/documents/UncategorizedDocumentEntry"
import { UncategorizedPendingDialog } from "@/components/documents/UncategorizedPendingDialog"
import { FormHeader } from "@/components/form-elements/FormHeader"
import { Card, CardContent } from "@/components/ui/card"
import { cn } from "@/lib/utils"

export function UncategorizedDocumentsCard() {
  const { uncategorized } = useDocuments()

  const { status, proceed, reset } = useBlocker({
    shouldBlockFn: () => !!uncategorized.length,
    enableBeforeUnload: false,
    withResolver: true,
  })

  return (
    <Card className="w-full border-0 shadow-sm">
      <CardContent>
        <FormHeader title="Uncategorized" />
        {reset && (
          <UncategorizedPendingDialog
            open={status === "blocked"}
            onClose={reset}
            onDismiss={proceed}
          />
        )}

        {uncategorized.length ? (
          <div role="table" className="flex w-full flex-col gap-2">
            <div
              role="row"
              className={cn(
                "hidden md:grid md:gap-2",
                "md:grid-cols-[2fr_2fr_2fr_0.5fr_0.5fr_0.5fr]",
                "text-muted-foreground text-sm font-semibold",
              )}
            >
              <span>Document Name</span>
              <span className="text-center">Category</span>
              <span className="text-center">Type</span>
              <span className="text-center">Preview</span>
              <span className="text-center">Confirm</span>
              <span className="text-center">Remove</span>
            </div>

            {uncategorized.map((doc) => (
              <UncategorizedDocumentEntry key={doc.uuid} doc={doc} />
            ))}
          </div>
        ) : (
          <p className="text-muted text-sm">
            Looks like you&apos;re all caught up here. Upload additional
            documents above to categorize &amp; add to your profile.
          </p>
        )}
      </CardContent>
    </Card>
  )
}
